import { useEffect, useState } from "react";

const Nav = () => {

    return (
        <div style={{ position : 'relative'}}>
            <div className="topbar-nav header navbar" role="banner" >
                <nav id="topbar">
                    <ul className="navbar-nav theme-brand flex-row  text-center" style={{display : 'none'}} >
                        <li className="nav-item theme-logo">
                            <a href="/dashboard">
                                <img src="assets/img/90x90.jpg" className="navbar-logo" alt="logo" />
                            </a>
                        </li>
                        <li className="nav-item theme-text">
                            <a href="/dashboard" className="nav-link"> CORK </a>
                        </li>
                    </ul>

                    <ul className="list-unstyled menu-categories" id="topAccordion">

                        <li className="menu single-menu active">
                            <a href="/dashboard" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle autodroprown">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                                    <span>Dashboard</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="dashboard" data-parent="#topAccordion">
                                <li>
                                    <a href="/dashboard"> Analytics </a>
                                </li>
                                <li className="active">
                                    <a href="/dashboard"> Sales </a>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#app" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-cpu"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>
                                    <span>Apps</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="app" data-parent="#topAccordion">
                                <li>
                                    <a href="apps_chat.html"> Chat </a>
                                </li>
                                <li>
                                    <a href="apps_mailbox.html"> Mailbox </a>
                                </li>
                                <li>
                                    <a href="/appstodolist"> Todo List </a>
                                </li>
                                <li>
                                    <a href="/appsnotes">Notes</a>
                                </li>
                                <li>
                                    <a href="/appsscrumboard">Task Board</a>
                                </li>
                                <li>
                                    <a href="apps_contacts.html">Contacts</a>
                                </li>
                                <li>
                                    <a href="apps_invoice.html">Invoice List</a>
                                </li>
                                <li>
                                    <a href="apps_calendar.html"> Calendar</a>
                                </li>
                            </ul>
                        </li>
                        
                        <li className="menu single-menu">
                            <a href="#components" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-box"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                                    <span>Components</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="components" data-parent="#topAccordion">
                                <li>
                                    <a href="component_tabs.html"> Tabs </a>
                                </li>
                                <li>
                                    <a href="component_accordion.html"> Accordions  </a>
                                </li>
                                <li>
                                    <a href="component_modal.html"> Modals </a>
                                </li>                            
                                <li>
                                    <a href="component_cards.html"> Cards </a>
                                </li>
                                <li>
                                    <a href="component_bootstrap_carousel.html">Carousel</a>
                                </li>
                                <li>
                                    <a href="component_blockui.html"> Block UI </a>
                                </li>
                                <li>
                                    <a href="component_countdown.html"> Countdown </a>
                                </li>
                                <li>
                                    <a href="component_counter.html"> Counter </a>
                                </li>
                                <li>
                                    <a href="component_sweetalert.html"> Sweet Alerts </a>
                                </li>
                                <li>
                                    <a href="component_timeline.html"> Timeline </a>
                                </li>
                                <li>
                                    <a href="component_snackbar.html"> Notifications </a>
                                </li>
                                <li>
                                    <a href="component_session_timeout.html"> Session Timeout </a>
                                </li>
                                <li>
                                    <a href="component_media_object.html"> Media Object </a>
                                </li>
                                <li>
                                    <a href="component_list_group.html"> List Group </a>
                                </li>
                                <li>
                                    <a href="component_pricing_table.html"> Pricing Tables </a>
                                </li>
                                <li>
                                    <a href="component_lightbox.html"> Lightbox </a>
                                </li>
                            </ul>
                        </li>


                        <li className="menu single-menu">
                            <a href="#uiKit" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-zap"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                                    <span>UI Kit</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="uiKit" data-parent="#topAccordion">
                                <li>
                                    <a href="ui_alerts.html"> Alerts </a>
                                </li>
                                <li>
                                    <a href="ui_avatar.html"> Avatar </a>
                                </li>
                                <li>
                                    <a href="ui_badges.html"> Badges </a>
                                </li>
                                <li>
                                    <a href="ui_breadcrumbs.html"> Breadcrumbs </a>
                                </li>                            
                                <li>
                                    <a href="ui_buttons.html"> Buttons </a>
                                </li>
                                <li>
                                    <a href="ui_buttons_group.html"> Button Groups </a>
                                </li>
                                <li>
                                    <a href="ui_color_library.html"> Color Library </a>
                                </li>
                                <li>
                                    <a href="ui_dropdown.html"> Dropdown </a>
                                </li>
                                <li>
                                    <a href="ui_infobox.html"> Infobox </a>
                                </li>
                                <li>
                                    <a href="ui_jumbotron.html"> Jumbotron </a>
                                </li>
                                <li>
                                    <a href="ui_loader.html"> Loader </a>
                                </li>
                                <li>
                                    <a href="ui_pagination.html"> Pagination </a>
                                </li>
                                <li>
                                    <a href="ui_popovers.html"> Popovers </a>
                                </li>
                                <li>
                                    <a href="ui_progress_bar.html"> Progress Bar </a>
                                </li>
                                <li>
                                    <a href="ui_search.html"> Search </a>
                                </li>
                                <li>
                                    <a href="ui_tooltips.html"> Tooltips </a>
                                </li>
                                <li>
                                    <a href="ui_treeview.html"> Treeview </a>
                                </li>
                                <li>
                                    <a href="ui_typography.html"> Typography </a>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#tables" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-layout"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
                                    <span>Tables</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="tables"  data-parent="#topAccordion">
                                <li>
                                    <a href="table_basic.html"> Basic </a>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#datatable" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> DataTables <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="datatable" data-parent="#datatable">
                                        <li>
                                            <a href="table_dt_basic.html"> Basic </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_basic-dark.html"> Dark </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_ordering_sorting.html"> Order Sorting </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_multi-column_ordering.html"> Multi-Column </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_multiple_tables.html"> Multiple Tables</a>
                                        </li>
                                        <li>
                                            <a href="table_dt_alternative_pagination.html"> Alt. Pagination</a>
                                        </li>
                                        <li>
                                            <a href="table_dt_custom.html"> Custom </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_range_search.html"> Range Search </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_html5.html"> HTML5 Export </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_live_dom_ordering.html"> Live DOM ordering </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_miscellaneous.html"> Miscellaneous </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#forms" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-clipboard"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
                                    <span>Forms</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="forms"  data-parent="#topAccordion">
                                <li>
                                    <a href="form_bootstrap_basic.html"> Basic </a>
                                </li>
                                <li>
                                    <a href="form_input_group_basic.html"> Input Group </a>
                                </li>
                                <li>
                                    <a href="form_layouts.html"> Layouts </a>
                                </li>
                                <li>
                                    <a href="form_validation.html"> Validation </a>
                                </li>
                                <li>
                                    <a href="form_input_mask.html"> Input Mask </a>
                                </li>
                                <li>
                                    <a href="form_bootstrap_select.html"> Bootstrap Select </a>
                                </li>
                                <li>
                                    <a href="form_select2.html"> Select2 </a>
                                </li>
                                <li>
                                    <a href="form_bootstrap_touchspin.html"> TouchSpin </a>
                                </li>
                                <li>
                                    <a href="form_maxlength.html"> Maxlength </a>
                                </li>
                                <li>
                                    <a href="form_checkbox_radio.html"> Checkbox &amp; Radio </a>
                                </li>
                                <li>
                                    <a href="form_switches.html"> Switches </a>
                                </li>
                                <li>
                                    <a href="form_wizard.html"> Wizards </a>
                                </li>
                                <li>
                                    <a href="form_fileupload.html"> File Upload </a>
                                </li>
                                <li>
                                    <a href="form_quill.html"> Quill Editor </a>
                                </li>
                                <li>
                                    <a href="form_markdown.html"> Markdown Editor </a>
                                </li>
                                <li>
                                    <a href="form_date_range_picker.html"> Date &amp; Range Picker </a>
                                </li>
                                <li>
                                    <a href="form_clipboard.html"> Clipboard </a>
                                </li>
                                <li>
                                    <a href="form_typeahead.html"> Typeahead </a>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#page" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-file"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
                                    <span>Pages</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="page"  data-parent="#topAccordion">
                                <li>
                                    <a href="pages_helpdesk.html"> Helpdesk </a>
                                </li>
                                <li>
                                    <a href="pages_contact_us.html"> Contact Form </a>
                                </li>
                                <li>
                                    <a href="pages_faq.html"> FAQ </a>
                                </li>
                                <li>
                                    <a href="pages_faq2.html"> FAQ 2 </a>
                                </li>
                                <li>
                                    <a href="pages_privacy.html"> Privacy Policy </a>
                                </li>
                                <li>
                                    <a href="pages_coming_soon.html"> Coming Soon </a>
                                </li>
                                <li>
                                    <a href="user_profile.html"> Profile </a>
                                </li>
                                <li>
                                    <a href="user_account_setting.html"> Account Settings </a>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#pages-error" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Error <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="pages-error" data-parent="#more"> 
                                        <li>
                                            <a href="pages_error404.html"> 404 </a>
                                        </li>
                                        <li>
                                            <a href="pages_error500.html"> 500 </a>
                                        </li>
                                        <li>
                                            <a href="pages_error503.html"> 503 </a>
                                        </li>
                                        <li>
                                            <a href="pages_maintenence.html"> Maintanence </a>
                                        </li>
                                    </ul>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#user-login" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Login <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="user-login" data-parent="#page"> 
                                        <li>
                                            <a href="auth_login.html"> Login </a>
                                        </li>
                                        <li>
                                            <a href="auth_login_boxed.html"> Login Boxed </a>
                                        </li>
                                    </ul>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#user-register" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Register <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="user-register" data-parent="#page"> 
                                        <li>
                                            <a href="auth_register.html"> Register </a>
                                        </li>
                                        <li>
                                            <a href="auth_register_boxed.html"> Register Boxed </a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="sub-sub-submenu-list">
                                    <a href="#user-passRecovery" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Password Recovery <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="user-passRecovery" data-parent="#page"> 
                                        <li>
                                            <a href="auth_pass_recovery.html"> Recover ID </a>
                                        </li>
                                        <li>
                                            <a href="auth_pass_recovery_boxed.html"> Recover ID Boxed </a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="sub-sub-submenu-list">
                                    <a href="#user-lockscreen" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Lockscreen <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="user-lockscreen" data-parent="#page"> 
                                        <li>
                                            <a href="auth_lockscreen.html"> Unlock </a>
                                        </li>
                                        <li>
                                            <a href="auth_lockscreen_boxed.html"> Unlock Boxed </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#more" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                                    <span>More</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="more" data-parent="#topAccordion">
                                <li>
                                    <a href="dragndrop_dragula.html"> Drag and Drop</a>
                                </li>
                                <li>
                                    <a href="widgets.html"> Widgets </a>
                                </li>
                                <li>
                                    <a href="map_jvector.html"> Vector Maps</a>
                                </li>
                                <li>
                                    <a href="charts_apex.html"> Charts </a>
                                </li>
                                <li>
                                    <a href="fonticons.html"> Font Icons </a>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#starter-kit" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Starter Kit <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu eq-animated eq-fadeInUp" id="starter-kit" data-parent="#more">
                                        <li>
                                            <a href="starter_kit_blank_page.html"> Blank Page </a>
                                        </li>
                                        <li>
                                            <a href="starter_kit_breadcrumb.html"> Breadcrumb </a>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="../../documentation/index.html"> Documentation </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>

            <div className="topbar-nav header navbar sticky" role="banner" style={{ position : 'fixed', top: '0px', visibility: 'hidden'}} >
                <nav id="topbar">
                    <ul className="navbar-nav theme-brand flex-row  text-center" style={{display : 'none'}} >
                        <li className="nav-item theme-logo">
                            <a href="/dashboard">
                                <img src="assets/img/90x90.jpg" className="navbar-logo" alt="logo" />
                            </a>
                        </li>
                        <li className="nav-item theme-text">
                            <a href="/dashboard" className="nav-link"> CORK </a>
                        </li>
                    </ul>

                    <ul className="list-unstyled menu-categories" id="topAccordion">

                        <li className="menu single-menu active">
                            <a href="#dashboard" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle autodroprown">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                                    <span>Dashboard</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="dashboard" data-parent="#topAccordion">
                                <li>
                                    <a href="/dashboard"> Analytics </a>
                                </li>
                                <li className="active">
                                    <a href="/dashboard"> Sales </a>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#app" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-cpu"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>
                                    <span>Apps</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="app" data-parent="#topAccordion">
                                <li>
                                    <a href="apps_chat.html"> Chat </a>
                                </li>
                                <li>
                                    <a href="apps_mailbox.html"> Mailbox </a>
                                </li>
                                <li>
                                    <a href="/appstodolist"> Todo List </a>
                                </li>
                                <li>
                                    <a href="/appsnotes">Notes</a>
                                </li>
                                <li>
                                    <a href="/appsscrumboard">Task Board</a>
                                </li>
                                <li>
                                    <a href="apps_contacts.html">Contacts</a>
                                </li>
                                <li>
                                    <a href="apps_invoice.html">Invoice List</a>
                                </li>
                                <li>
                                    <a href="apps_calendar.html"> Calendar</a>
                                </li>
                            </ul>
                        </li>
                        
                        <li className="menu single-menu">
                            <a href="#components" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-box"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                                    <span>Components</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="components" data-parent="#topAccordion">
                                <li>
                                    <a href="component_tabs.html"> Tabs </a>
                                </li>
                                <li>
                                    <a href="component_accordion.html"> Accordions  </a>
                                </li>
                                <li>
                                    <a href="component_modal.html"> Modals </a>
                                </li>                            
                                <li>
                                    <a href="component_cards.html"> Cards </a>
                                </li>
                                <li>
                                    <a href="component_bootstrap_carousel.html">Carousel</a>
                                </li>
                                <li>
                                    <a href="component_blockui.html"> Block UI </a>
                                </li>
                                <li>
                                    <a href="component_countdown.html"> Countdown </a>
                                </li>
                                <li>
                                    <a href="component_counter.html"> Counter </a>
                                </li>
                                <li>
                                    <a href="component_sweetalert.html"> Sweet Alerts </a>
                                </li>
                                <li>
                                    <a href="component_timeline.html"> Timeline </a>
                                </li>
                                <li>
                                    <a href="component_snackbar.html"> Notifications </a>
                                </li>
                                <li>
                                    <a href="component_session_timeout.html"> Session Timeout </a>
                                </li>
                                <li>
                                    <a href="component_media_object.html"> Media Object </a>
                                </li>
                                <li>
                                    <a href="component_list_group.html"> List Group </a>
                                </li>
                                <li>
                                    <a href="component_pricing_table.html"> Pricing Tables </a>
                                </li>
                                <li>
                                    <a href="component_lightbox.html"> Lightbox </a>
                                </li>
                            </ul>
                        </li>


                        <li className="menu single-menu">
                            <a href="#uiKit" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-zap"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                                    <span>UI Kit</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="uiKit" data-parent="#topAccordion">
                                <li>
                                    <a href="ui_alerts.html"> Alerts </a>
                                </li>
                                <li>
                                    <a href="ui_avatar.html"> Avatar </a>
                                </li>
                                <li>
                                    <a href="ui_badges.html"> Badges </a>
                                </li>
                                <li>
                                    <a href="ui_breadcrumbs.html"> Breadcrumbs </a>
                                </li>                            
                                <li>
                                    <a href="ui_buttons.html"> Buttons </a>
                                </li>
                                <li>
                                    <a href="ui_buttons_group.html"> Button Groups </a>
                                </li>
                                <li>
                                    <a href="ui_color_library.html"> Color Library </a>
                                </li>
                                <li>
                                    <a href="ui_dropdown.html"> Dropdown </a>
                                </li>
                                <li>
                                    <a href="ui_infobox.html"> Infobox </a>
                                </li>
                                <li>
                                    <a href="ui_jumbotron.html"> Jumbotron </a>
                                </li>
                                <li>
                                    <a href="ui_loader.html"> Loader </a>
                                </li>
                                <li>
                                    <a href="ui_pagination.html"> Pagination </a>
                                </li>
                                <li>
                                    <a href="ui_popovers.html"> Popovers </a>
                                </li>
                                <li>
                                    <a href="ui_progress_bar.html"> Progress Bar </a>
                                </li>
                                <li>
                                    <a href="ui_search.html"> Search </a>
                                </li>
                                <li>
                                    <a href="ui_tooltips.html"> Tooltips </a>
                                </li>
                                <li>
                                    <a href="ui_treeview.html"> Treeview </a>
                                </li>
                                <li>
                                    <a href="ui_typography.html"> Typography </a>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#tables" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-layout"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
                                    <span>Tables</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="tables"  data-parent="#topAccordion">
                                <li>
                                    <a href="table_basic.html"> Basic </a>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#datatable" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> DataTables <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="datatable" data-parent="#datatable">
                                        <li>
                                            <a href="table_dt_basic.html"> Basic </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_basic-dark.html"> Dark </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_ordering_sorting.html"> Order Sorting </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_multi-column_ordering.html"> Multi-Column </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_multiple_tables.html"> Multiple Tables</a>
                                        </li>
                                        <li>
                                            <a href="table_dt_alternative_pagination.html"> Alt. Pagination</a>
                                        </li>
                                        <li>
                                            <a href="table_dt_custom.html"> Custom </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_range_search.html"> Range Search </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_html5.html"> HTML5 Export </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_live_dom_ordering.html"> Live DOM ordering </a>
                                        </li>
                                        <li>
                                            <a href="table_dt_miscellaneous.html"> Miscellaneous </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#forms" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-clipboard"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
                                    <span>Forms</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="forms"  data-parent="#topAccordion">
                                <li>
                                    <a href="form_bootstrap_basic.html"> Basic </a>
                                </li>
                                <li>
                                    <a href="form_input_group_basic.html"> Input Group </a>
                                </li>
                                <li>
                                    <a href="form_layouts.html"> Layouts </a>
                                </li>
                                <li>
                                    <a href="form_validation.html"> Validation </a>
                                </li>
                                <li>
                                    <a href="form_input_mask.html"> Input Mask </a>
                                </li>
                                <li>
                                    <a href="form_bootstrap_select.html"> Bootstrap Select </a>
                                </li>
                                <li>
                                    <a href="form_select2.html"> Select2 </a>
                                </li>
                                <li>
                                    <a href="form_bootstrap_touchspin.html"> TouchSpin </a>
                                </li>
                                <li>
                                    <a href="form_maxlength.html"> Maxlength </a>
                                </li>
                                <li>
                                    <a href="form_checkbox_radio.html"> Checkbox &amp; Radio </a>
                                </li>
                                <li>
                                    <a href="form_switches.html"> Switches </a>
                                </li>
                                <li>
                                    <a href="form_wizard.html"> Wizards </a>
                                </li>
                                <li>
                                    <a href="form_fileupload.html"> File Upload </a>
                                </li>
                                <li>
                                    <a href="form_quill.html"> Quill Editor </a>
                                </li>
                                <li>
                                    <a href="form_markdown.html"> Markdown Editor </a>
                                </li>
                                <li>
                                    <a href="form_date_range_picker.html"> Date &amp; Range Picker </a>
                                </li>
                                <li>
                                    <a href="form_clipboard.html"> Clipboard </a>
                                </li>
                                <li>
                                    <a href="form_typeahead.html"> Typeahead </a>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#page" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-file"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
                                    <span>Pages</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="page"  data-parent="#topAccordion">
                                <li>
                                    <a href="pages_helpdesk.html"> Helpdesk </a>
                                </li>
                                <li>
                                    <a href="pages_contact_us.html"> Contact Form </a>
                                </li>
                                <li>
                                    <a href="pages_faq.html"> FAQ </a>
                                </li>
                                <li>
                                    <a href="pages_faq2.html"> FAQ 2 </a>
                                </li>
                                <li>
                                    <a href="pages_privacy.html"> Privacy Policy </a>
                                </li>
                                <li>
                                    <a href="pages_coming_soon.html"> Coming Soon </a>
                                </li>
                                <li>
                                    <a href="user_profile.html"> Profile </a>
                                </li>
                                <li>
                                    <a href="user_account_setting.html"> Account Settings </a>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#pages-error" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Error <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="pages-error" data-parent="#more"> 
                                        <li>
                                            <a href="pages_error404.html"> 404 </a>
                                        </li>
                                        <li>
                                            <a href="pages_error500.html"> 500 </a>
                                        </li>
                                        <li>
                                            <a href="pages_error503.html"> 503 </a>
                                        </li>
                                        <li>
                                            <a href="pages_maintenence.html"> Maintanence </a>
                                        </li>
                                    </ul>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#user-login" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Login <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="user-login" data-parent="#page"> 
                                        <li>
                                            <a href="auth_login.html"> Login </a>
                                        </li>
                                        <li>
                                            <a href="auth_login_boxed.html"> Login Boxed </a>
                                        </li>
                                    </ul>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#user-register" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Register <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="user-register" data-parent="#page"> 
                                        <li>
                                            <a href="auth_register.html"> Register </a>
                                        </li>
                                        <li>
                                            <a href="auth_register_boxed.html"> Register Boxed </a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="sub-sub-submenu-list">
                                    <a href="#user-passRecovery" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Password Recovery <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="user-passRecovery" data-parent="#page"> 
                                        <li>
                                            <a href="auth_pass_recovery.html"> Recover ID </a>
                                        </li>
                                        <li>
                                            <a href="auth_pass_recovery_boxed.html"> Recover ID Boxed </a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="sub-sub-submenu-list">
                                    <a href="#user-lockscreen" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Lockscreen <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu" id="user-lockscreen" data-parent="#page"> 
                                        <li>
                                            <a href="auth_lockscreen.html"> Unlock </a>
                                        </li>
                                        <li>
                                            <a href="auth_lockscreen_boxed.html"> Unlock Boxed </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li className="menu single-menu">
                            <a href="#more" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                                    <span>More</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="more" data-parent="#topAccordion">
                                <li>
                                    <a href="dragndrop_dragula.html"> Drag and Drop</a>
                                </li>
                                <li>
                                    <a href="widgets.html"> Widgets </a>
                                </li>
                                <li>
                                    <a href="map_jvector.html"> Vector Maps</a>
                                </li>
                                <li>
                                    <a href="charts_apex.html"> Charts </a>
                                </li>
                                <li>
                                    <a href="fonticons.html"> Font Icons </a>
                                </li>
                                <li className="sub-sub-submenu-list">
                                    <a href="#starter-kit" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Starter Kit <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg> </a>
                                    <ul className="collapse list-unstyled sub-submenu eq-animated eq-fadeInUp" id="starter-kit" data-parent="#more">
                                        <li>
                                            <a href="starter_kit_blank_page.html"> Blank Page </a>
                                        </li>
                                        <li>
                                            <a href="starter_kit_breadcrumb.html"> Breadcrumb </a>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="../../documentation/index.html"> Documentation </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}
export default Nav;